// Detección reactiva de viewport desktop (>= 768px = md). Mismo idiom que el resto
// de Atlas (matchMedia + listener; no hay hook central en el repo). Se usa para la
// lógica de montaje que el CSS no cubre (paneles como sheet vs columna, etc.).

import { useEffect, useState } from 'react';

const QUERY = '(min-width: 768px)';

export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(QUERY).matches : true,
  );
  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const handler = (e: MediaQueryListEvent) => setIsDesktop(e.matches);
    mq.addEventListener('change', handler);
    // Sincronizar por si cambió entre el render inicial y el efecto.
    setIsDesktop(mq.matches);
    return () => mq.removeEventListener('change', handler);
  }, []);
  return isDesktop;
}
